import { useState, useEffect } from "react";
import { ImageOff } from "lucide-react";

const DELAYS = [1500, 6000, 20000, 45000];

// <img> that retries transient failures (rate limiting, network blips) with backoff
export function RetryImg({ src, className, alt = "", ...rest }) {
  const [attempt, setAttempt] = useState(0);
  const [failed, setFailed] = useState(false);
  useEffect(() => { setAttempt(0); setFailed(false); }, [src]);
  if (!src) return null;
  if (failed) return <div className={`${className} flex items-center justify-center bg-white/5`}><ImageOff className="w-5 h-5 text-white/20" /></div>;
  const url = attempt ? `${src}${src.includes("?") ? "&" : "?"}r=${attempt}` : src;
  const onError = () => {
    if (attempt >= DELAYS.length) return setFailed(true);
    setTimeout(() => setAttempt((a) => a + 1), DELAYS[attempt] * (0.8 + Math.random() * 0.4));
  };
  return <img src={url} alt={alt} className={className} onError={onError} {...rest} />;
}
